import { Button, CircularProgress } from '@mui/material';
import { PaymentMethod } from '../../../store/config/types';

interface SubmitButtonProps {
  isRegisterStep: boolean;
  creatingCommerce: boolean;
  updatingCommerce: boolean;
  paymentMethod: PaymentMethod | null;
  disabled?: boolean;
  loading?: boolean;
}

function SubmitButton({
  isRegisterStep,
  creatingCommerce,
  updatingCommerce,
  paymentMethod,
  disabled,
  loading,
}: SubmitButtonProps) {
  return (
    <div className="button-row-field">
      <Button
        type="submit"
        color="primary"
        variant="contained"
        form="payment-method-form"
        fullWidth={!isRegisterStep}
        disabled={creatingCommerce || updatingCommerce || disabled}
      >
        {creatingCommerce || updatingCommerce || loading ? (
          <CircularProgress size={28} color="inherit" />
        ) : paymentMethod ? (
          'Guardar cambios'
        ) : (
          'Agregar medio de pago'
        )}
      </Button>
    </div>
  );
}

export default SubmitButton;
